import React from "react";
import { useTranslation } from "react-i18next";

import "./DashboardHeader.scss";
import NotificationButton from "../../../Buttons/NotificationButton/NotificationButton";
import UserAvatar from "../../../UserAvatar/UserAvatar";
import useAuth from "../../../../hooks/useAuth";

function DashboardHeader() {
  const { userProfile } = useAuth();
  const { t } = useTranslation("dashboard");

  return (
    <>
      <header className="dashboard-header">
        <div className="greeting-container">
          <UserAvatar />
          <h1 className="greeting">
            {t("hi")} {userProfile?.username}
          </h1>
        </div>
        <div className="bell-container">
          <NotificationButton hasNotifications />
        </div>
      </header>
    </>
  );
}

export default DashboardHeader;
